import React, { useState, useEffect, useRef } from 'react';
import DataTable from "react-data-table-component";
import "./ActivityLog.css";
import moment from 'moment';
import Form from 'react-bootstrap/Form';
import FormSelect from 'react-bootstrap/FormSelect';
import SRQService from '../../Services/SRQService';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import Cookies from 'universal-cookie';
import axios from 'axios';
import ProjectsService from '../../Services/ProjectsService';
import ActivityLogService from '../../Services/ActivityLogService';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { locale } from 'moment/moment';


import uiCloseSVG from '../../Assets/Images/ui-close.svg'
const ActivityLog = () => {

  const popoverRefreshAndLoad = (data) => (

    <Popover id="popover-basic-activityLog" className="custom-popover">
  <Popover.Body style={{ margin: 0, padding: '6px 6px', color: '#fff', fontSize: '14px', textAlign: 'center', background: '#2d32aa', borderRadius: '6px' }}>
    {data}
  </Popover.Body>
</Popover>

  );

  const customStyles = {
    header: {
      style: {
        minHeight: '100px',
        color: '#2d32aa',
        borderRadius: 0,
        borderLeft: 'none',
        borderRight: 'none',
        background: '#f6f7f9',
        fontSize: '35px',
        textAlign: 'left',
        fontWeight: '600px',
      },
    },
    headRow: {
      style: {
        background: '#2d32aa',
        color: '#fff',
        padding: '14px ​12px',
        borderRadius: 0,
        fontWeight: 'normal',
        borderTop: '1.5px solid #3e6a85',
        borderBottom: '1.5px solid #3e6a85',
        borderLeft: 'none',
        minWidth: '120px',
        fontSize: '14.1px',
      },
    },
    headCells: {

      style: {
        '&:not(:last-of-type)': {
        },
        textAlign: 'left',
      },
    },
    cells: {
      style: {
        '&:not(:last-of-type)': {
          //paddingBottom: '10px',
          color: '#000',
          textAlign: 'left',
          padding: '14px ​12px',
          opacity: '21',
          fontSize: '13px',
        },
      },
    },
  };
  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadActivityLogDataTable, setLoadActivityLogDataTable] = useState(false);
  const [isSystemLogEnabled, setIsSystemLogEnabled] = useState(false);
  const [startDate, setStartDate] = useState();
  //const [endDate, setEndDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isoStartDate, setIsoStartDate] = useState();
  //const [endDate, setEndDate] = useState();
  const [isoEndDate, setIsoEndDate] = useState();

  const [existingCompany, setExistingCompany] = useState([]);
  const [selectedRequestTypeCompany, setSelectedRequestTypeCompany] = useState('');// selected companyId
  const [selectedRequestTypeProject, setSelectedRequestTypeProject] = useState('');// selected projectId
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [projectName, setProjectName] = useState("");

  const [isDisabled, setIsDisabled] = useState(true);

  const [scopes, setScopes] = useState([
    'All Activities',
    'Project Management',
    'All User Management',
    'Privileged User Management',
    'Production Access',
  ]);

  const [selectedScope, setSelectedScope] = useState('All Activities');
  const [companyId, setCompanyId] = useState();
  const [calendarDate, setCalendarDate] = useState(new Date());
  const startDateCalendarRef = useRef(null);
  const endDateCalendarRef = useRef(null);
  const [showStartDateCalendar, setShowStartDateCalendar] = useState(false);
  const [showEndDateCalendar, setShowEndDateCalendar] = useState(false);
  const formattedStartDate = startDate ? `${startDate.getDate().toString().padStart(2, '0')}-${(startDate.getMonth() + 1).toString().padStart(2, '0')}-${startDate.getFullYear()}` : "";
  const formattedEndDate = endDate ? `${endDate.getDate().toString().padStart(2, '0')}-${(endDate.getMonth() + 1).toString().padStart(2, '0')}-${endDate.getFullYear()}` : "";    const [filterReferees, setFilterReferees] = useState(false);

  const [filterCompanyName, setFilterCompanyName] = useState("");
  const [filterProjectName, setFilterProjectName] = useState("");
  const [filterScopes, setFilterScopes] = useState('All Activities');
  let queryParams  = {
    scope:'',
    includeSystemLogs:'false',
    periodFrom:'',
    periodTo:'',
    limit:101,

   };
   const toggleStartDateCalendar = () => {
    setShowStartDateCalendar(!showStartDateCalendar);
  };

  const toggleEndDateCalendar = () => {
    setShowEndDateCalendar(!showEndDateCalendar);
  };



  useEffect(() => {

    ProjectsService.getAllProjects().then((response) => {
      setExistingCompany(response.data[0].companyProjects);
    }).catch(error =>{
      console.log(error);
    });

	}, []);


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        startDateCalendarRef.current &&
        !startDateCalendarRef.current.contains(event.target)
      ) {
        setShowStartDateCalendar(false);
      }
      if (
        endDateCalendarRef.current &&
        !endDateCalendarRef.current.contains(event.target)
      ) {
        setShowEndDateCalendar(false);
      }
    };

    document.body.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.body.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);



  useEffect(() => {
    if(filterReferees){
    fetchActivityLogs();
    setFilterReferees(false);
    }
  },[filterReferees])


  const handleSelectChange = (event) => {
    let eValue = event.target.value;
    if (eValue == "Select Existing Company") {
      setSelectedRequestTypeCompany(eValue);
      setSelectedCompany("");
      setCompanyName("");
      setIsDisabled(true);
    } else {
      setSelectedRequestTypeCompany(eValue);
      let eData = existingCompany.filter((record) => eValue == record.id);
      setSelectedCompany(eData);
      setCompanyName(eData[0].name);
      setIsDisabled(false);
    }
    //setLoadActivityLogDataTable(false);
    };
    const handleSelectProject = (event) => {
      let eValue = event.target.value;
      let exCompanyObject = existingCompany.filter((record) => selectedRequestTypeCompany == record.id);
      var pName = exCompanyObject[0].projects.filter((record) => eValue == record.id).map((e)=>{return e.name});
      //alert(JSON.stringify());
      setProjectName(pName);
      //filter((record) => eValue == record.id)
      //let name12 = JSON.stringify(eData);
      //console.log('--------------'+name12);
      //alert(name12);
      setSelectedRequestTypeProject(eValue);
      //setProjectName(pName);
      if (eValue == "Select Existing Project") {
        setIsDisabled(true);
      }else{
       // let eData = existingCompany.projects.filter((record) => eValue == record.id);
        
        setIsDisabled(false);
      }
      //setLoadActivityLogDataTable(false);
    }


    const handleSelectScope = (event) => {
      let eValue = event.target.value;
      setSelectedScope(eValue);
      //setLoadActivityLogDataTable(false);
    }

    const clearProjectFilter = async () => {
      //setSelectedRequestTypeProject("");
      //onClick={() => setSelectedRequestTypeProject("");}
        //fetchActivityLogs();
        setFilterReferees(true);
    }

    const clearAllFields = () => {
      setSelectedRequestTypeCompany("");
      setSelectedCompany("");
      setCompanyName("");
      setSelectedRequestTypeProject("");
      setSelectedScope("");
      setIsSystemLogEnabled(false);
      setIsDisabled(true);
      setStartDate("");
      setIsoStartDate("");
      setEndDate("");
      setIsoEndDate("");
      setLogData('');
      setLoadActivityLogDataTable(false);
    };
    const fetchActivityLogs = async() => {
      setFilterCompanyName(companyName);
      setFilterProjectName(projectName);
      setFilterScopes(selectedScope);
        setLoading(true);
        // queryParams.companyId=selectedRequestTypeCompany;
        // queryParams.projectId=selectedRequestTypeProject;
        queryParams.includeSystemLogs=isSystemLogEnabled;
        queryParams.scope=selectedScope;
        queryParams.periodFrom=isoStartDate;
        queryParams.periodTo=isoEndDate;
        if(!selectedRequestTypeProject)
        {
          const response = await ActivityLogService.getActivityLogsByCompanyId(selectedRequestTypeCompany,queryParams)
          .then(response => {
            
            console.log(response.data)
            setLogData(response.data.log);
        setLoadActivityLogDataTable(true);
         
          setLoading(false);
            console.log(response.data.log); 
       }).catch(error => {
            console.log(error); 
       });
        }
        else if(selectedRequestTypeProject)
        {
          const response = await ActivityLogService.getActivityLogsByProjectId(selectedRequestTypeProject,queryParams)
          .then(response => {
            
            setLogData(response.data.log);
            setLoadActivityLogDataTable(true);
         //setData({});
          setLoading(false);
            console.log(response.data); 
       }).catch(error => {
            console.log(error); 
       });

        }
        
    };
    const handleDateChange = (date,dateType) => {
      var isoDate ;
   
      
      if(dateType==="startDate")
      {
        const selectedDate = new Date(date);
        const utcDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()));
        utcDate.setUTCHours(0, 0, 0, 0);
        setStartDate(utcDate);
        isoDate=utcDate.toISOString();
          setIsoStartDate(isoDate);
          console.log(isoDate);
          setShowStartDateCalendar(false); // Close the start date calendar


         //setting enddate to current date on selection of the start date
          const currentDate = new Date();
          console.log('Current Date:', currentDate);
          const currentUtcDate = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
          console.log('Current UTC Date:', currentUtcDate);

          setEndDate(currentDate);
          currentUtcDate.setUTCHours(23, 59, 59, 999);
          const isoEndDate = currentUtcDate.toISOString();
          setIsoEndDate(isoEndDate);
          
      }
      else if(dateType==="endDate")
      {
        const selectedDate = new Date(date);
        const utcDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()));

    // Set the time to end of the day (23:59:59.999)
    utcDate.setUTCHours(23, 59, 59, 999);
    setEndDate(selectedDate);

    // Convert the UTC date to ISO string
    isoDate = utcDate.toISOString();
    setIsoEndDate(isoDate);
    setShowEndDateCalendar(false); // Close the end date calendar
      }
      
     
    };
    function getNumberOfPages(rowCount, rowsPerPage) {
        return Math.ceil(rowCount / rowsPerPage);
      }
      
      function toPages(pages) {
        const results = [];
      
        for (let i = 1; i < pages+1; i++) {
          results.push(i);
        }
      
        return results;
      }
      const popover = (data) =>(  
        
        <Popover id={`popover-positioned-bottom`}>  
                <Popover.Header as="h5"></Popover.Header>  
                <Popover.Body style={{color:'#a2a2a2'}}>  
                  {data}  
                </Popover.Body>  
              </Popover> 
      ); 
      
      const columns = [
        {
          name: <span className="activitylog-table-header">ID</span>,
          selector: row => row.id,
          minWidth: "50px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.id ?? '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Created</span>,
          selector: row => row.creationDate,
          minWidth: "160px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.creationDate ? moment(row.creationDate).format("DD-MM-YYYY hh:mm:ss") : '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Action</span>,
          selector: row => row.action,
          minWidth: "160px",
          wrap: true,
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.action || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Project Name</span>,
          selector: row => row.projectName,
          minWidth: "160px",
          wrap: true,
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.projectName || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Performed By</span>,
          selector: row => row.userName,
          minWidth: "140px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.userName || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Performed On</span>,
          selector: row => row.subjectUserName,
          minWidth: "140px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.subjectUserName || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">API Name</span>,
          selector: row => row.apiName,
          minWidth: "120px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.apiName || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Property Name</span>,
          selector: row => row.propertyName,
          minWidth: "120px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.propertyName || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Service Request Ext Id</span>,
          selector: row => row.srqExtId,
          minWidth: "180px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.srqExtId || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Credential</span>,
          selector: row => row.credential,
          minWidth: "190px",
          sortable: true,
          cell: row => <span className="activitylog-table-cell">{row.credential || '-'}</span>
        },
        {
          name: <span className="activitylog-table-header">Message</span>,
          selector: row => row.message,
          minWidth: "350px",
          sortable: true,
          cell: row => (
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={popover(row.message || '-')}
            >
              <span className="activitylog-table-cell truncate">
                {row.message || '-'}
              </span>
            </OverlayTrigger>
          )
        }
      ];
      const customSort = (rows, selector, direction) => {
        return rows.sort((a, b) => {
            const aField = selector(a);
            const bField = selector(b);
    
            let comparison = 0;
    
            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }
    
            return direction === 'asc' ? comparison * -1 : comparison;
        });
    };
   
      
      // RDT exposes the following internal pagination properties
const BootyPagination = ({
    rowsPerPage,
    rowCount,
    onChangePage,
    onChangeRowsPerPage, // available but not used here
    currentPage
  }) => {
    const handleBackButtonClick = () => {
      onChangePage(currentPage - 1);
    };
  
    const handleNextButtonClick = () => {
      onChangePage(currentPage + 1);
    };
  
    const handlePageNumber = (e) => {
      onChangePage(Number(e.target.value));
    };
  
    const pages = getNumberOfPages(rowCount, rowsPerPage);
    const pageItems = toPages(pages);
    const nextDisabled = currentPage === pageItems.length;
    const previosDisabled = currentPage === 1;
  
    return (
      <nav>
        <ul className="pagination justify-content-end pagination-large m-3 me-0">
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleBackButtonClick}
              disabled={previosDisabled}
              aria-disabled={previosDisabled}
              aria-label="previous page"
            >
              Previous
            </button>
          </li>
          {pageItems.map((page) => {
            const className =
              page === currentPage ? "page-item active" : "page-item";
  
            return (
              <li key={page} className={className}>
                <button
                  className="page-link"
                  onClick={handlePageNumber}
                  value={page}
                >
                  {page}
                </button>
              </li>
            );
          })}
          <li className="page-item">
            <button
              className="page-link"
              onClick={handleNextButtonClick}
              disabled={nextDisabled}
              aria-disabled={nextDisabled}
              aria-label="next page"
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    );
  };

  const handleChange = (e) => {
    setIsSystemLogEnabled(e.target.checked);
    
    }
  

       return (
       
        
        <div
            id="activityLogContainer"
            className="container-fluid"
            style={{ height: "100%" }}
          >
            <div
              className="activity-log-header"
              style={{
                minHeight: "10px",
                color: "#2d32aa"
              }}
            >
              <div className="empty-cont-header-view-activity" style={{ minHeight: "10px" }}>
                <h1>VIEW ACTIVITIES LOG</h1>
              </div>
            </div>

            <div className="Activity-log-main-content">
              <div className="container first">

                {/* --- FILTERS: 2 ROWS LAYOUT --- */}
                <section className="activity-log-list-w">
                  {/* First line: Company, Project, Scope */}
                  <div style={{ display: "flex", gap: "32px", alignItems: "flex-end", marginBottom: "20px" }}>
                    <div style={{ minWidth: 320, maxWidth: 307 }}>
                      <label className="bold-label">Company Name</label>
                      <Form.Select
                        id='activityCompanyDD'
                        defaultValue="Select Existing Company"
                        value={selectedRequestTypeCompany}
                        onChange={handleSelectChange}
                        style={{ width: "100%", borderRadius: 0, maxWidth: 307 }}
                      >
                        <option className="textdefault" value={"Select Existing Company"}>
                          {"Select Existing Company"}
                        </option>
                        {existingCompany &&
                          existingCompany.map((cp) => (
                            <option value={cp.id}>{cp.name}</option>
                          ))}
                      </Form.Select>
                    </div>
                    <div style={{ minWidth: 260, maxWidth: 320 }}>
                      <label className="bold-label">Project Name</label>
                      <Form.Select
                        id='activityProjectDD'
                        defaultValue="Select Existing Project"
                        value={selectedRequestTypeProject}
                        onChange={handleSelectProject}
                        style={{ width: "100%", borderRadius: 0, maxWidth: 300 }}
                        disabled={isDisabled}
                      >
                        <option className="textdefault" value={"Select Existing Project"}>
                          {"Select Existing Project"}
                        </option>
                        {existingCompany &&
                          existingCompany
                            .filter((cp) => cp.id == selectedRequestTypeCompany)
                            .flatMap((companyProjects) => companyProjects.projects)
                            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                            .map(cproject => (
                              <option value={cproject.id}>{cproject.name}</option>
                            ))
                        }
                      </Form.Select>
                    </div>
                    <div style={{ minWidth: 200, maxWidth: 250 }}>
                      <label className="bold-label">Scope</label>
                      <Form.Select
                        id="activityScopeDD"
                        value={selectedScope}
                        onChange={handleSelectScope}
                        style={{ width: "100%", borderRadius: 0, maxWidth: 220 }}
                        disabled={isDisabled}
                      >
                        <option className="textdefault" value={"Select Scope"}>
                          {"Select Scope"}
                        </option>
                        {scopes &&
                          scopes.map((scope) => (
                            <option value={scope}>{scope}</option>
                          ))}
                      </Form.Select>
                    </div>
                  </div>

                  {/* Second line: Start Date, End Date, System Logs toggle, Buttons */}
                  <div style={{ display: "flex", gap: "32px", alignItems: "flex-end" }}>
                    <div style={{ minWidth: 200, maxWidth: 220 }}>
                      <label className="bold-label">Start date</label>
                      <input
                        type="text"
                        value={startDate ? formattedStartDate : ''}
                        className='calendarInput'
                        placeholder='Start'
                        onClick={toggleStartDateCalendar}
                        readOnly
                        style={{ width: "100%", maxWidth: 200 }}
                      />
                      {showStartDateCalendar && (
                        <div ref={startDateCalendarRef} className='calendar-wrapper'>
                          <Calendar
                            className="custom-calendar"
                            onChange={(date) => handleDateChange(date, 'startDate')}
                            value={startDate || new Date()} />
                        </div>
                      )}
                    </div>
                    <div style={{ minWidth: 200, maxWidth: 220 }}>
                      <label className="bold-label">End date</label>
                      <input
                        type="text"
                        className='calendarInput'
                        placeholder='End'
                        disabled={!startDate}
                        value={endDate ? formattedEndDate : ''}
                        onClick={toggleEndDateCalendar}
                        readOnly
                        style={{ width: "100%", maxWidth: 200 }}
                      />
                      {showEndDateCalendar && (
                        <div ref={endDateCalendarRef} className="calendar-wrapper">
                          <Calendar
                            onChange={(date) => handleDateChange(date, 'endDate')}
                            value={endDate || new Date()}
                            className="custom-calendar"
                          />
                        </div>
                      )}
                    </div>
                    {/* System Logs toggle moved here */}
                    <div className="form-check form-switch ms-3 mt-4" style={{ minWidth: 220 }}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="chkSystemLog"
                        checked={isSystemLogEnabled}
                        onChange={handleChange}
                        disabled={isDisabled}
                      />
                      <label
                        className="form-check-label mt-1 bold-label"
                        htmlFor="chkSystemLog"
                      >
                        Include System Logs
                      </label>
                    </div>
                    {/* Buttons */}
                    <div className="form-f-w list-table-btn" disabled={isDisabled}>
                      <OverlayTrigger trigger="hover" placement="top" overlay={popoverRefreshAndLoad("Refresh")} style={{ pointerEvents: 'none' }}>
                        <button
                          disabled={isDisabled}
                          onClick={clearAllFields}
                          id="resetActivityFilters"
                          style={{
                            fontWeight: 'bolder',
                            width: 48,
                            height: 40,
                            borderRadius: 8,
                            border: "1px solid #ccc",
                            // background: "#e9ecef",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                          data-inverted
                        >
                          <i className="bi bi-arrow-clockwise" style={{ fontSize: 22 }}></i>
                        </button>
                      </OverlayTrigger>
                      <OverlayTrigger trigger="hover" placement="top" overlay={popoverRefreshAndLoad("Submit")} style={{ pointerEvents: 'none' }}>
                        <button
                          disabled={isDisabled}
                          style={{
                            fontWeight: 'bolder',
                            width: 48,
                            height: 40,
                            borderRadius: 8,
                            border: "1px solid #ccc",
                            // background: "#e9ecef",
                            padding: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                          data-inverted
                          id="submitActivityLogFilter"
                          onClick={fetchActivityLogs}
                        >
                          <i className="bi bi-arrow-right" style={{ fontSize: 22 }}></i>
                        </button>
                      </OverlayTrigger>
                    </div>
                  </div>
                </section>
                {/* ...existing code for filter buttons... */}
                {loadActivityLogDataTable && loadActivityLogDataTable === true ?
                  <div className='activityLogDataTable'>

                    <div className="d-flex gap-2 mb-3 mt-4">
                      <span className="">Filters:</span>
                      {(selectedRequestTypeProject != '' && selectedRequestTypeProject != null) ? <>

                        <button type="button" className="activityFilterButton d-flex justify-content-center" onClick={clearAllFields}>
                          <tr>
                            <td><img src={uiCloseSVG} width="12" height="12" className="opacity-50 me-1" /></td>
                            <td><span >{filterCompanyName}</span></td>
                          </tr>
                        </button>

                        <button type="button" className="activityFilterButton d-flex justify-content-center"
                          onClick={() => { setSelectedRequestTypeProject(""); setFilterReferees(true); }}>
                          <tr>
                            <td><img src={uiCloseSVG} width="12" height="12" className="opacity-50 me-1" /></td>
                            <td><span >{filterProjectName}</span></td>
                          </tr>
                        </button>

                      </> :
                        <button type="button" className="activityFilterButton d-flex justify-content-center" onClick={clearAllFields}>
                          <tr>
                            <td><img src={uiCloseSVG} width="12" height="12" className="opacity-50 me-1" /></td>
                            <td><span >{filterCompanyName}</span></td>
                          </tr>
                        </button>
                      }


                      <button type="button" className="activityFilterButton d-flex justify-content-center"
                        onClick={() => { setSelectedScope('All Activities'); setFilterReferees(true); }}
                        disabled={filterScopes === 'All Activities' ? true : false}
                      >
                        <tr>
                          <td><img src={uiCloseSVG} width="12" height="12" className="opacity-50 me-1" /></td>
                          <td>< >{filterScopes}</></td>
                        </tr>
                      </button>


                    </div>

                    <div style={{ overflowX: 'auto', width: '100%' }}>
                      <div className="activitylog-table-scroll">
                        <DataTable
                          columns={columns}
                          data={logData}
                          paginationComponent={BootyPagination}
                          highlightOnHover={true}
                          customStyles={customStyles}
                          progressPending={loading}
                          sortFunction={customSort}
                          defaultSortFieldId={5}
                          pagination
                          paginationPerPage={25}
                        />
                      </div>
                    </div>
                  </div> : <></>
                }
              </div>
            </div>
          </div>
    

          
       

    
);







}




export default ActivityLog;